export enum IncomeType {
  PRIMARY_INCOME = 'PRIMARY_INCOME',
  ADDITIONAL_INCOME = 'ADDITIONAL_INCOME',
  PREVIOUS_INCOME = 'PREVIOUS_INCOME',
}
